import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';

import PageHeader from 'components/page-header';
import Content from 'components/theme/content';
import { PATH_APPLICATIONS } from 'app-constants';

const useStyles = makeStyles({
  root: {
    textAlign: 'center',
    height: '50vh'
  }
});

export default function NotFound() {
  const classes = useStyles();
  return (
    <>
      <PageHeader title="Page not found !" />
      <Content>
        <Grid
          container
          alignItems="center"
          justify="center"
          className={classes.root}
        >
          <Grid item xs={12}>
            <Typography
              variant="h5"
              color="textSecondary"
              className={classes.message}
            >
              Uh ho! The page you requested could not be found. Go to{' '}
              <Link to={PATH_APPLICATIONS}>Applications List.</Link>
            </Typography>
          </Grid>
        </Grid>
      </Content>
    </>
  );
}
